import { render, staticRenderFns } from "./BotManWidgetHandler.vue?vue&type=template&id=4458e15e"
import script from "./BotManWidgetHandler.vue?vue&type=script&lang=js"
export * from "./BotManWidgetHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports